/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChargePointCompositeSchedule } from '../../models/charge-point-composite-schedule';

export interface GetChargePointCompositeSchedule$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected charge point
 */
  chargePointUid: string;

/**
 * The uid of the selected connector or 0 for requesting general chargepoint
 */
  connectorUid: string;
}

export function getChargePointCompositeSchedule(http: HttpClient, rootUrl: string, params: GetChargePointCompositeSchedule$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargePointCompositeSchedule>> {
  const rb = new RequestBuilder(rootUrl, getChargePointCompositeSchedule.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('chargePointUid', params.chargePointUid, {});
    rb.path('connectorUid', params.connectorUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChargePointCompositeSchedule>;
    })
  );
}

getChargePointCompositeSchedule.PATH = '/stations/{uid}/drive/chargepoints/{chargePointUid}/getcompositeschedule/{connectorUid}';
